import React, { FC, Fragment, ReactElement, useContext } from 'react'
import { BrandingArea, BrandingConfig, BrandingData, CMEBranding } from '../Types'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { LanguageContext } from '../../Common/Contexts'
import { BrandingFormEntry } from './BrandingFormEntry'
import { DEFAULT_CME_ID } from '../../AddUser/Constants'
import { isStringNotEmpty } from '../../../NonReact/utils/GlobalFunctions'
import { NameSpacing } from '../../../NonReact/utils/NameSpacing'
import { EMPTY_STRING } from '../../../NonReact/constants/Common'
import { HIDE } from '../../../NonReact/constants/class-names'

type Props = {
    parentID: string
    brandingConfig: BrandingConfig[]
    viewOnly: boolean
    selectedCME?: string
    existingBranding?: CMEBranding
    isTabActive: boolean
}

export const BrandingFormEntries: FC<Props> = ({
    parentID,
    brandingConfig,
    viewOnly,
    selectedCME,
    existingBranding,
    isTabActive
}: Props): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler

    return (
        <div className={isTabActive ? EMPTY_STRING : HIDE} key={`branding-form-entries-div-${parentID}`}>
            {brandingConfig?.map(
                ({ id, title, entries, rootOnly }: BrandingArea<BrandingData>, parentIndex: number): ReactElement =>
                    !rootOnly || (rootOnly && selectedCME === DEFAULT_CME_ID) ? (
                        <Fragment key={`${id}-${title}-${parentIndex}`}>
                            {isStringNotEmpty(title) ? (
                                <h3 className='branding-subtitle'>{language.get(title) ?? title}</h3>
                            ) : (
                                <></>
                            )}
                            {entries.map(
                                (brandingData: BrandingData, index: number): ReactElement => (
                                    <BrandingFormEntry
                                        key={`branding-form-entry-${brandingData.fieldName}-${index}`}
                                        viewOnly={viewOnly}
                                        selectedCME={selectedCME}
                                        brandingData={brandingData}
                                        fieldNameFunction={(fieldName: string): string =>
                                            NameSpacing(parentID, NameSpacing(id ?? EMPTY_STRING, fieldName))
                                        }
                                        existingBranding={existingBranding}
                                    />
                                )
                            )}
                        </Fragment>
                    ) : (
                        <Fragment key={`branding-form-entries-div-${parentID}`}></Fragment>
                    )
            )}
        </div>
    )
}
